import dayjs from 'dayjs';
import plugin from 'dayjs/plugin/customParseFormat';

dayjs.extend(plugin);

export const getIsValidDateRange = (dateRange: Date[]): boolean => {
	/** No valid date when no dateRange is provided or it's not an array of 2 dates */
	if (
		!dateRange ||
		!Array.isArray(dateRange) ||
		dateRange.length !== 2 ||
		!dateRange.every((date) => date instanceof Date)
	) {
		return false;
	}

	/** Dates are only valid when dayjs says so */
	if (dayjs(dateRange[0]).isValid() && dayjs(dateRange[1]).isValid()) {
		return true;
	}

	return false;
};
